import { z } from "zod";

import { BannerSection } from "@widgets/banner";

import { DynamicZoneSchema } from "@shared/content-types";
import { ButtonBaseSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

export const EcotrapDetailsSchema = z.object({
  difficulty: z.string(),
  distance_time: z.string(),
  elevation: z.string(),
  end: z.string(),
  id: z.number(),
  start: z.string(),
  trackFile: StrapiMediaSchema,
  // «Файл тропы» может быть либо загруженным файлом, либо ссылкой
  // со своим текстом кнопки
  trackLink: z.string().min(1).optional().nullable(),
  trackLinkText: z.string().min(1).optional().nullable(),
  type: z.string(),
  button: ButtonBaseSchema,
  mapLink: z.string(),
});

export const EcotrapsTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  name: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  ekotropies: z.any(),
});

export const EcotrapSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  title: z.string().min(1),
  slug: z.string().min(1),
  trailStatus: z.enum(["close", "open"]).optional().nullable(),
  details: EcotrapDetailsSchema,
  gallery: z.array(StrapiMediaSchema),
  ecotrap_type: EcotrapsTypeSchema,
  content: DynamicZoneSchema,
  banner: BannerSection.dynamic,
});

export const EcotrapDtoSchema = z.array(EcotrapSchema);
